export var UserError;
(function (UserError) {
    UserError["UNKNOWN_USER"] = "unknown_user";
    UserError["DUPLICATE_USER"] = "duplicate_user";
    UserError["EMAIL_INUSE"] = "email_in_use";
    UserError["WALLET_INUSE"] = "wallet_in_use";
})(UserError || (UserError = {}));
